import type { FieldValidation } from '@rjsf/utils';
import type { ProductServiceValue } from './function';
import { normalizeParentComponentMode } from './parentComponentMode';

/**
 * Validation function for the AsyncProductAndServiceSelect field extension.
 *
 * This is invoked by the scaffolder form on submission.
 * It enforces required sub-fields (product, service) based on the JSON Schema
 * `required` array, and enforces `parentComponent` when `showParentComponent`
 * is `"required"`.
 */
export function asyncProductAndServiceSelectValidation(
  data: ProductServiceValue,
  field: FieldValidation,
  context: {
    apiHolder: unknown;
    formData: Record<string, unknown>;
    schema: Record<string, unknown>;
    uiSchema?: Record<string, unknown>;
  },
): void {
  const requiredFields: string[] = Array.isArray(context.schema?.required)
    ? context.schema.required
    : [];

  if (requiredFields.includes('product') && !data?.product?.trim()) {
    field.addError('Product is required.');
  }

  if (requiredFields.includes('service') && !data?.service?.trim()) {
    field.addError('Service is required.');
  }

  const raw = (context.uiSchema?.['ui:options'] as Record<string, unknown>)
    ?.showParentComponent;
  const mode = normalizeParentComponentMode(raw);

  if (mode === 'required' && !data?.parentComponent) {
    field.addError('Parent Component is required.');
  }
}
